type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * LinkedIn-style "share" hook-arrow used on the shorts surface action rail.
 * A thin curved tail sweeping up and right into an open chevron arrowhead —
 * matches the iconography LinkedIn paints alongside Like / Comment in their
 * vertical-video player.
 *
 * Outline-only (fill: none); driven by `strokeColor` so callers can match
 * the rail's white-on-video treatment or any other foreground.
 */
const LinkedInShareIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    strokeColor = 'currentColor',
    strokeWidth = '1.6',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      {/* Hooked tail: starts low-left, curves up and right toward the
          arrowhead's base. */}
      <path
        d="M3.5 19.5 C 3.5 12.5, 9 7.5, 17.5 6.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Open chevron arrowhead pointing up-right. */}
      <path
        d="M11.5 3.5 L 18.5 6.5 L 15.5 13.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkedInShareIcon;
